/**
  * Automatic generated for gulp
  * params hostings general
	* params hostings personal
  */
 import { hostings } from './hostings';
 export const env = hostings.general;
 